<template>
  <CRow>
    <CCol col="auto mx-2">
      <div class="my-3 text-center" v-if="Object.keys(row).length">
        <b-avatar v-if="String(row.avatar).trim().length" variant="light" :src="row.avatar" size="6rem"></b-avatar>
        <b-avatar v-else variant="info" text="Dak Land" size="6rem" class="b-avatar-expand bg-color-animation"></b-avatar>
      </div>
    </CCol>
    <CCol>
      <label class="font-weight-bold text-crimson">Thông tin thêm:</label>
      <ul class="pl-4" v-if="Object.keys(row).length">
        <li>
          <strong>Email: </strong>
          {{ row.email }}
        </li>
        <li>
          <strong>Điện thoại: </strong>
          {{ row.phone }}
        </li>
        <li>
          <strong>Cấp Tỉnh: </strong>
          {{ row.province_name }}
        </li>
        <li>
          <strong>Cấp Huyện: </strong>
          {{ row.district_name }}
        </li>
        <li>
          <strong>Cấp Xã: </strong>
          {{ row.commune_name }}
        </li>
      </ul>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: "ExpandInfoList",
  props: {
    row: {
      type: Object
    }
  }
}
</script>

<style scoped>
.b-avatar {
  border: 3px solid #cccccc;
}
</style>
